module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-text-quote-reece.fbc5088.png";